var _dec,
  _class,
  _Create,
  _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/groups/create/index.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { changeValue, submit, reset } from '../../../actions/group_editor';
const messages = defineMessages({
  title: {
    "id": "groups.form.title",
    "defaultMessage": "Enter a new group title"
  },
  description: {
    "id": "groups.form.description",
    "defaultMessage": "Enter the group description"
  },
  coverImage: {
    "id": "groups.form.coverImage",
    "defaultMessage": "Upload a banner image"
  },
  coverImageChange: {
    "id": "groups.form.coverImageChange",
    "defaultMessage": "Banner image selected"
  },
  create: {
    "id": "groups.form.create",
    "defaultMessage": "Create group"
  }
});
const mapStateToProps = state => ({
  title: state.getIn(['group_editor', 'title']),
  description: state.getIn(['group_editor', 'description']),
  coverImage: state.getIn(['group_editor', 'coverImage']),
  disabled: state.getIn(['group_editor', 'isSubmitting'])
});
const mapDispatchToProps = dispatch => ({
  onTitleChange: value => dispatch(changeValue('title', value)),
  onDescriptionChange: value => dispatch(changeValue('description', value)),
  onCoverImageChange: value => dispatch(changeValue('coverImage', value)),
  onSubmit: routerHistory => dispatch(submit(routerHistory)),
  reset: () => dispatch(reset())
});
let Create = (_dec = connect(mapStateToProps, mapDispatchToProps), _dec(_class = injectIntl(_class = withRouter(_class = (_Create = class Create extends React.PureComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleTitleChange", e => {
      this.props.onTitleChange(e.target.value);
    });
    _defineProperty(this, "handleDescriptionChange", e => {
      this.props.onDescriptionChange(e.target.value);
    });
    _defineProperty(this, "handleCoverImageChange", e => {
      this.props.onCoverImageChange(e.target.files[0]);
    });
    _defineProperty(this, "handleSubmit", e => {
      e.preventDefault();
      this.props.onSubmit(this.props.history);
    });
    props.reset();
  }
  render() {
    const {
      title,
      description,
      coverImage,
      disabled,
      intl
    } = this.props;
    return /*#__PURE__*/React.createElement("form", {
      className: "group-form",
      method: "post",
      onSubmit: this.handleSubmit,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 78,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement("div", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 79,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement("input", {
      className: "standard",
      type: "text",
      value: title,
      disabled: disabled,
      onChange: this.handleTitleChange,
      placeholder: intl.formatMessage(messages.title),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 80,
        columnNumber: 11
      }
    })), /*#__PURE__*/React.createElement("div", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 89,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement("textarea", {
      className: "standard",
      type: "text",
      value: description,
      disabled: disabled,
      onChange: this.handleDescriptionChange,
      placeholder: intl.formatMessage(messages.description),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 90,
        columnNumber: 11
      }
    })), /*#__PURE__*/React.createElement("div", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 99,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: "group_cover_image",
      className: classNames('group-form__file-label', {
        'group-form__file-label--selected': coverImage !== null
      }),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 100,
        columnNumber: 11
      }
    }, intl.formatMessage(coverImage === null ? messages.coverImage : messages.coverImageChange)), /*#__PURE__*/React.createElement("input", {
      type: "file",
      className: "group-form__file",
      id: "group_cover_image",
      disabled: disabled,
      onChange: this.handleCoverImageChange,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 103,
        columnNumber: 11
      }
    }), /*#__PURE__*/React.createElement("button", {
      className: "standard-small",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 110,
        columnNumber: 11
      }
    }, intl.formatMessage(messages.create))));
  }
}, _defineProperty(_Create, "propTypes", {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  coverImage: PropTypes.object,
  disabled: PropTypes.bool,
  intl: PropTypes.object.isRequired,
  onTitleChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  onDescriptionChange: PropTypes.func.isRequired,
  onCoverImageChange: PropTypes.func.isRequired,
  history: PropTypes.object
}), _Create)) || _class) || _class) || _class);
export { Create as default };